export default "__VITE_ASSET__bf5244c1__"